module.exports = __webpack_public_path__ + "img/green.74c56f0c.jpg";